import { IGcpAppDispatch } from "../../../redux/store";
import { getSiteState, IStoreState } from "../../../redux/rootReducer";
import { fitGeojsonBounds } from "./NavigationLayer";

export const navigationLayerAdded =
  () => async (dispatch: IGcpAppDispatch, getState: () => IStoreState) => {
    const siteState = getSiteState(getState());
    dispatch(fitGeojsonBounds(siteState.data.boundary));
  };
